const t = "styles-module__textareaInput___DK0f1", e = "styles-module__error___ELvhI", r = {
  textareaInput: t,
  error: e
};
export {
  r as default,
  e as error,
  t as textareaInput
};
